import React from 'react'
import { LinkButton } from '../../components/Button/LinkButton'
import './AuditLogDisabledBox.scss'

export const AuditLogDisabledBox: React.FC = () => {
  return (
    <div className='audit-log-disabled-box'>
      <div className='audit-log-disabled-icon'>
        <i className='bi bi-card-list' />
      </div>
      <div className='audit-log-disabled-content'>
        <div className='audit-log-disabled-text'>
          <span className='audit-log-disabled-description'>
            <b className='audit-log-disabled-title'>Track actions for compliance. </b>
            Audit Log records system activity automatically.
            <br />
            Enable it once and stay audit-ready.
          </span>
        </div>
        <div className='audit-log-disabled-cta'>
          <LinkButton variant='primary' to='/workspace/setup/settings/data-retention' className='audit-log-disabled-cta-button'>
            <b className='audit-log-disabled-cta-label'>Enable</b>
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
